import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route, Navigate } from "react-router-dom";

import Index from "./pages/Index";

import DynamicBackground from "@/components/DynamicBackground";
import WhatsAppFloat from "@/components/WhatsAppFloat";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <div style={{ position: 'relative', minHeight: '100vh' }}>
        <DynamicBackground />
        <div style={{ position: 'relative', zIndex: 2 }}>
          <Routes>
            {/* Home */}
            <Route path="/" element={<Index />} />

            {/* Redirección de productos al inicio */}
            <Route path="/productos" element={<Navigate to="/" replace />} />

            {/* Catch-all a Home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
        <WhatsAppFloat />
      </div>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
